import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';
import { useKpiUnit } from 'src/hooks/useKpiUnit';
import { useLTDataContext } from '../../../contexts/LTDataContext';
import { calculateRoi } from '../../../../../utils/calculateRoi';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { BarChart3 } from 'lucide-react';

export const ROI: React.FC = () => {
  const { roi, isError, isLoading } = useLTDataContext();

  const { isEuro } = useKpiUnit();

  const keyMetricData: KeyMetricData = useMemo(() => {
    const effectSum = roi.monthly.reduce((prev, curr) => {
      return prev + curr.totalEffect;
    }, 0);

    const investmentsSum = roi.monthly.reduce((prev, curr) => {
      return prev + curr.investments;
    }, 0);

    return {
      isLoading,
      isError,
      name: 'ROI',
      // Chart formatting flag: ROI is a ratio, never euro-formatted
      isEuro: false,
      summaryValue: calculateRoi({
        mediaIncrementalSales: effectSum,
        investment: investmentsSum,
        isEuro,
      }),
      data: roi.monthly.map((month) => ({
        utcEpoch: month.utcEpoch,
        value: month.totalEffectROI,
      })),
    };
  }, [roi, isError, isLoading, isEuro]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      isEuro={keyMetricData.isEuro}
      title="ROI"
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={isLoading}
      isError={isError}
      icon={<ChakraIcon as={BarChart3} boxSize={5} color="gray.500" />}
    />
  );
};
